/** @jsx jsx */
import { jsx } from '@emotion/react';

import { useParams } from 'js/lib/useRouter';

import SkillSetCardsModule from 'bundles/page-config-common/components/enterprise/SkillSetCardsModule';
import HomeSection from 'bundles/page-config-common/components/shared/HomeSection';
import { usePageContext } from 'bundles/page-config-common/contexts/PageContext';
import { useEnterpriseSkillsets } from 'bundles/page-config-common/contexts/enterprise/EnterpriseSkillSetsContext';
import { useEnterpriseProductFeatures } from 'bundles/unified-common/contexts/EnterpriseProductFeaturesContext';
import { useProgram } from 'bundles/unified-common/contexts/EnterpriseProgramContext';

const EnterpriseSkillSetCardsModuleRenderer = () => {
  const { programSlug } = useParams();
  const program = useProgram();
  const pageContext = usePageContext();
  const features = useEnterpriseProductFeatures();
  const { hasError, skillsetsLoading, skillsets } = useEnterpriseSkillsets();

  const skillSetLength = program?.metadata?.linkedTargetSkillProfileIds?.length;

  if (pageContext?.isEnterprise && program && features && skillSetLength) {
    return (
      <HomeSection className="PageConfig_SkillSetCardsComponent">
        <SkillSetCardsModule
          // @ts-expect-error TS2322 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
          programSlug={programSlug}
          skillSetLength={skillSetLength}
          skillsets={skillsets}
          skillsetsLoading={skillsetsLoading}
          hasError={hasError}
        />
      </HomeSection>
    );
  } else {
    return null;
  }
};

export default EnterpriseSkillSetCardsModuleRenderer;
